import new_logo from '@assets/component/Header/logo-1752058808881-blue.svg';
import bird_logo from '@assets/component/Header/bird_logo.png';
import { useNavUtils } from '@assets/utils/NavUtils';

interface LogoProps {
    width?: number;
    className?: string;
    onClick?: () => void;
}

export const Logo = (props: LogoProps) => {
    const width = props.width || 160;
    return (
        <img
            style={{ cursor: 'pointer', objectFit: 'contain' }}
            className={props.className}
            src={new_logo}
            width={width}
            onClick={() => {
                if (props.onClick) {
                    props.onClick();
                }
            }}
        />
    );
};

export const LogoBird = () => {
    return <img style={{ objectFit: 'contain' }} src={bird_logo} width={50} />;
};
